export const isOdd = num => num % 2 === 1;

export const isNumber = value => typeof value === 'number' && !isNaN(value);

export const getValueFromRange = (val, min, max) => Math.min(Math.max(val, min), max);
